import { useMaintenanceStore } from '../../stores/maintenanceStore';
import { useAuthStore } from '../../stores/authStore';
import { MaintenancePage } from '../../pages/MaintenancePage';

/**
 * Shows the maintenance page to non-admin users when maintenance mode is active.
 * Admins pass through and see the normal site (with a header banner).
 * Must be nested inside SetupGuard (which populates the maintenance store).
 */
export function MaintenanceGuard({ children }: { children: React.ReactNode }) {
  const enabled = useMaintenanceStore((s) => s.enabled);
  const role = useAuthStore((s) => s.user?.role);

  if (enabled && role !== 'admin') {
    return <MaintenancePage />;
  }

  return <>{children}</>;
}
